import { render, staticRenderFns } from "./attachmentPreview.vue?vue&type=template&id=1a65101a&scoped=true"
import script from "./attachmentPreview.vue?vue&type=script&lang=js"
export * from "./attachmentPreview.vue?vue&type=script&lang=js"
import style0 from "./attachmentPreview.vue?vue&type=style&index=0&id=1a65101a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a65101a",
  null
  
)

export default component.exports